import React from "react";
import "./GlobalTransition.scss";
import { huyaIconAssetsCdn } from "@huyafed/huya-icon-assets";

/** (深色背景用) */
const IMG_DARK = huyaIconAssetsCdn.pageLoadingWhiteWebp;
/** (浅色背景) */
const IMG_LIGHT = huyaIconAssetsCdn.pageLoadingBlackWebp;

interface IGlobalTransitionProps {
  className?: string;
  style?: React.CSSProperties;
  /** 主题。light-浅色模式，dark-深色模式 */
  theme?: "light" | "dark";
  /** 图片资源 */
  src?: string;
}
const GlobalTransition: React.FC<React.PropsWithChildren<IGlobalTransitionProps>> = props => {
  const theme = props.theme || "light";
  return (
    <div
      className={"hy-loading-wrapper2" + `${props.className ? ` ${props.className}` : ""}`}
      style={{
        ...(props.style || {}),
      }}
    >
      <img
        className="hy-loading2"
        src={props.src ? props.src : theme === "light" ? IMG_LIGHT : IMG_DARK}
      />
    </div>
  );
};

export default GlobalTransition;
